// "Save to File Browser" from AI Studio: pick (or create) a folder once and save every
// image into it, the way the A/B hero card saves to files. (POR-14685 / POR-14746)

async function saveImageToFolder({ url, fileName }, folderId) {
  const response = await fetch(url);

  if (!response.ok) return false;

  const blob = await response.blob();
  const form = new FormData();
  form.append('canvas_image', new File([blob], fileName, { type: blob.type || 'image/png' }));
  form.append('filename', fileName);
  form.append('folder_id', folderId);

  const { data } = await axios.post('/file/save-canvas-to-files', form);

  return !(data && data.status === 'error');
}

// images: [{ url, fileName }]. Resolves once saved, or as soon as the picker is closed.
export async function saveImagesToFileBrowser(images) {
  if (!images.length || typeof window.openSelectFolderModal !== 'function') return;

  const chosen = await window.openSelectFolderModal({
    mode: 'selectAndCreate',
    viewTabs: false,
    modalTitle: 'Select Folder',
  });
  const folder = chosen && chosen[0];

  if (!folder || !folder.id) return;

  let saved = 0;

  for (const image of images) {
    try {
      if (await saveImageToFolder(image, folder.id)) saved += 1;
    } catch (e) {
      console.warn('Save to File Browser failed', e);
    }
  }

  const where = `File Browser › ${folder.name || 'the selected folder'}`;

  if (!saved) {
    toastr.error('Could not save to File Browser.');
  } else if (saved < images.length) {
    toastr.warning(`Saved ${saved} of ${images.length} images to ${where}.`);
  } else if (images.length === 1) {
    toastr.success(`Saved to ${where}.`);
  } else {
    toastr.success(`Saved ${saved} images to ${where}.`);
  }
}
